// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------
import ContentImage from '@components/common/ContentImage';
import SellLabel from '@components/common/SellLabel';

function mansionUrl(id: number): string {
  return `/karte/mansions/detail/${id}/`;
}

// Section for render component ----------------------------------------------------------------------------------------
export default function MansionCard(props: any) {
  const { data } = props;
  return (
    <Box className="group w-80">
      <Box className="relative">
        {data.com_estate_count >= 1 && (
          <div className="absolute top-0 right-0 z-10">
            <SellLabel />
          </div>
        )}
        <ContentImage
          className="md:h-64 md:aspect-video md:object-cover  group-hover:opacity-60"
          src={data.mansion_thumbnail_image_url}
          alt={data.mansion_name}
          href={mansionUrl(data.mansion_id)}
        />
      </Box>
      <Box className="mx-2">
        <Link underline="none" href={mansionUrl(data.mansion_id)} variant="body1">
          <Box className="mt-3 text-rf-blue font-bold" sx={{ display: 'block' }}>
            {data.mansion_name}
          </Box>

          <Typography className="text-rf-black" variant="body2" sx={{ marginTop: 1 }}>
            {data.address_display}
          </Typography>
          <Typography className="text-rf-black" variant="body2" sx={{ marginTop: 1 }}>
            {data.transit_display}
          </Typography>
          <Typography className="text-rf-black" variant="body2" sx={{ marginTop: 1 }}>
            築年月：{data.build_created_date_display}
          </Typography>
        </Link>
      </Box>
    </Box>
  );
}
